import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

export const SkeletonMemberShort = (): ReactNode => (
  <div className="flex size-full flex-col items-center rounded-lg bg-bg-primary px-5 py-7 lg:px-7 lg:py-9">
    <Skeleton className="mb-4 size-20 rounded-full" />
    <Skeleton className="mb-2 h-5 w-32 rounded-lg" />
    <Skeleton className="h-5 w-24 rounded-lg" />
  </div>
)
